import { PRODUCT_FORM } from '@/modules/Contract/constants'
import { Contract, ProductResponse } from '@/modules/Contract/types'
import { Path, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm } from 'vnetwork-ui'
import ServiceTimes from '../../Base/ServiceTimes'
import Configuration from './Configuration'

interface TranscodingProps {
    index: number
    isPOC?: boolean
    product: ProductResponse
}

const Transcoding: React.FC<TranscodingProps> = ({
    index,
    product,
    isPOC = false,
}) => {
    const formControl = useFormContext<Contract>()
    const { t } = useTranslation()

    return (
        <div>
            <GridHookForm
                subForm
                actions={[]}
                data={[
                    {
                        formItemProps: {
                            name: `order.products.[${index}].product_form` as Path<Contract>,
                            type: 'select',
                            options: PRODUCT_FORM(t),
                            placeholder: t('service-form'),
                            label: t('service-form'),
                            allowClear: false,
                        },
                        className: isPOC ? 'hidden' : 'col-span-4',
                    },
                    {
                        renderEditComponent: () => {
                            return (
                                <Configuration
                                    isPOC={isPOC}
                                    product_config_options={
                                        product.product_config_options
                                    }
                                    index={index}
                                />
                            )
                        },
                        className: 'col-span-4',
                    },
                ]}
                formControl={formControl}
            />

            {!isPOC && <ServiceTimes index={index} />}
        </div>
    )
}

export default Transcoding
